import { useCallback } from 'react';

import { DownloadIcon } from '~components/icons/DownloadIcon';
import { AssetId } from '~modules/media-library/model/Asset';
import { DownloadVariation } from '~modules/media-library/model/DownloadVariation';
import { AddToMyfilesButton } from '~modules/media-library/view/AddToMyfilesButton';
import { Button } from '~modules/media-library/view/Button';
import { ShareAction } from '~modules/media-library/view/ShareModal/ShareAction';
import { shareFileMam } from '~services/api/calls/file';
import { makeProgramaticallyLinkClick } from '~utils/link';

type Props = {
  downloadVariation: DownloadVariation;
  shareAction: ShareAction;
};

export function ShareVariationListItemPanelController({
  downloadVariation,
  shareAction = ShareAction.Download,
}: Props) {
  // Handler: onDownload fetches download url and gives it back
  const onDownload = useCallback((href: string) => makeProgramaticallyLinkClick({ href }), []);

  // Handler: add to myfiles
  const handleOnAddToMyfiles = useCallback(async (id: AssetId) => {
    return await shareFileMam(id);
  }, []);

  return (
    <>
      {shareAction === ShareAction.Download ? (
        <Button variant="icon" onClick={() => onDownload(downloadVariation.downloadUrl)}>
          <DownloadIcon />
        </Button>
      ) : null}
      {shareAction === ShareAction.AddToMyfiles ? (
        <AddToMyfilesButton assetId={downloadVariation.id} onAddToMyfiles={handleOnAddToMyfiles} />
      ) : null}
    </>
  );
}
